import type { Product, Variant } from '@nucleus-commerce/api-client/admin';

import { useVariants } from '../hooks/use-variants';

import { VariantsCard, type VariantsCardExtension } from './variants-card';
import { MasterVariantsCard } from './variants-card-master';

export { VARIANTS_SECTION_ID } from './variants-card';

const NO_VARIANTS: readonly Variant[] = [];

export interface VariantsSectionProps {
  product: Product;
  /** A host page's own rows, such as a store's prices; the master variant fields otherwise. */
  extension?: VariantsCardExtension;
}

/** The product's variants as a card of its own, below the Options card. */
export function VariantsSection({ product, extension }: VariantsSectionProps) {
  const query = useVariants(product.id);
  const state = {
    product,
    variants: query.data ?? NO_VARIANTS,
    isPending: query.isPending,
    error: query.error,
    onRetry: () => void query.refetch(),
  };
  return extension ? <VariantsCard {...state} {...extension} /> : <MasterVariantsCard {...state} />;
}
